function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(0.000000, -30.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 30.000000)"
}, React.createElement("path", {
  d: "M37.7142857,17.5102041 C37.7142857,18.3857143 37.0071429,19.1020408 36.1428571,19.1020408 L1.57142857,19.1020408 C0.707142857,19.1020408 2.55795385e-13,18.3857143 2.55795385e-13,17.5102041 L2.55795385e-13,1.59183673 C2.55795385e-13,0.716326531 0.707142857,-3.62376795e-13 1.57142857,-3.62376795e-13 L36.1428571,-3.62376795e-13 C37.0071429,-3.62376795e-13 37.7142857,0.716326531 37.7142857,1.59183673 L37.7142857,17.5102041 Z",
  fill: "#3D68E3"
}), React.createElement("path", {
  d: "M11.033,8.57522449 L13.2188571,5.80065306 C13.8725714,4.93469388 15.1422857,6.04102041 14.4257143,6.86877551 C13.673,7.77293878 12.881,8.7535102 12.1267143,9.75795918 L14.6897143,12.9909796 C15.3811429,13.9460816 13.9998571,14.8613878 13.321,13.9190204 L11.0078571,10.9152245 L8.734,13.9842857 C8.09285714,14.9123265 6.67228571,13.8696735 7.38885714,13.0037143 L9.91414286,9.75795918 C9.12214286,8.75191837 8.35528571,7.77293878 7.59,6.86877551 C6.79957143,5.91367347 8.26885714,4.93469388 8.84714286,5.82771429 L11.033,8.57522449 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M16.2407143,6.28297959 C16.2407143,5.86273469 16.5927143,5.50616327 17.0327143,5.50616327 C17.435,5.50616327 17.7744286,5.86432653 17.7744286,6.28297959 L17.7744286,12.6598776 L21.1922857,12.6598776 C22.4227143,12.6598776 22.4494286,14.3265306 21.1922857,14.3265306 L17.0342857,14.3265306 C16.5942857,14.3265306 16.2422857,14.0097551 16.2422857,13.5513061 L16.2422857,6.28297959 L16.2407143,6.28297959 L16.2407143,6.28297959 Z",
  fillRule: "nonzero",
  fill: "#FFFFFF"
}), React.createElement("path", {
  d: "M23.5745714,7.42910204 C23.8637143,4.95857143 27.544,4.51444898 29.2788571,5.86432653 C30.1337143,6.56314286 29.2285714,7.67106122 28.4742857,7.11073469 C27.544,6.51379592 25.4335714,6.23363265 25.1695714,7.55485714 C24.8301429,9.64334694 30.2955714,8.44787755 30.2075714,11.8337143 C30.1195714,15.0667347 25.4964286,15.141551 23.7615714,13.6913878 C23.3451429,13.347551 23.3592857,12.7888163 23.5855714,12.4433878 C23.9124286,12.1138776 24.2754286,11.9992653 24.7044286,12.3558367 C25.7337143,13.0673878 28.3862857,13.6022449 28.5732857,11.7939184 C28.4114286,9.91236735 23.1848571,11.0441633 23.5745714,7.42910204 Z",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), React.createElement("path", {
  d: "M36.1428571,19.1020408 L6.28571429,19.1020408 L6.28571429,20.6938776 L36.1428571,20.6938776 C37.0071429,20.6938776 37.7142857,19.977551 37.7142857,19.1020408 L37.7142857,17.5102041 C37.7142857,18.3857143 37.0071429,19.1020408 36.1428571,19.1020408 Z",
  fillOpacity: 0.5,
  fill: "#6C7B99"
}))));

var SvgXlsx = function SvgXlsx(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "38px",
    height: "21px",
    viewBox: "0 0 38 21",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgXlsx, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/xlsx.79e02e68.svg";
export { ForwardRef as ReactComponent };